import { Module } from 'vuex-smart-module';
import EventHistoryActions from './actions';
import EventHistoryGetters from './getters';
import EventHistoryMutations from './mutations';
import { EventHistoryState } from './state';

export default new Module({
  state: EventHistoryState,
  mutations: EventHistoryMutations,
  actions: EventHistoryActions,
  getters: EventHistoryGetters,
});
